<ng-container *ngIf="state$ | async as state">
  <app-list *ngIf="state=='list'"></app-list>
  <app-edit *ngIf="state=='edit'"></app-edit>
  <app-add *ngIf="state=='add'"></app-add>
</ng-container>
